module.exports = __webpack_public_path__ + "img/q5.9f97ecba.png";